import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'plNum'
})
export class PlNumPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (typeof value !== 'number') {
      return value;
    }
    const intgr = Math.floor(value);
    let frct: any;
    frct = value - intgr;

    if (frct > 0) {
      let mn = 10;
      if (args !== undefined && typeof args === 'number') {
        mn = Math.pow(10, args);
      }
      frct = Math.floor(mn * frct);
      if (frct > 0) {
        frct = ',' + frct;
      } else {
        frct = '';
      }
    } else {
      frct = '';
    }


    return '' + intgr + frct;
  }

}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/pipes/pl-num.pipe.ts